export enum actions {
    SET_CONFIG_DATA = 'SET_CONFIG_DATA',
    SET_MARKET_DATA = 'SET_MARKET_DATA',
    SET_MARKET_CONFIG = 'SET_MARKET_CONFIG',
    GET_RESPONSE = 'GET_RESPONSE'
 }
